import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import VehicleTypeList from "../../components/VehicleType";

const VehicleTypePage = (): ReactElement => {
  return (
    <Layout>
      <VehicleTypeList />
    </Layout>
  );
};

export default VehicleTypePage;
